import {mapGetters, mapActions, mapMutations} from 'vuex';
import Header from '@/components/header/index.vue'
import leftBar from '@/components/left-bar/index.vue'
import TableOptions from '@/components/table/options/index.vue'
import Table from '@/components/table/list/index.vue'
import popupProduct from '@/components/popups/catalog/product/index.vue'

export default {
    components: {
        Header,
        leftBar,
        TableOptions,
        Table,
        popupProduct,
    },
    data() {
        return {
            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs: [
                {
                    key: 'id',
                    label: 'id'
                },
                {
                    key: 'photo',
                    labelKey: 'catalogProducts.photo',
                },
                {
                    key: 'title',
                    labelKey: 'catalogProducts.title',
                },
                {
                    key: 'model',
                    labelKey: 'catalogProducts.model',
                },
                {
                    key: 'lack_less_quantity',
                    labelKey: 'lackOf.quantity',
                },
                {
                    key: 'lack_less_min_quantity',
                    labelKey: 'lackOf.min_quantity',
                },
                {
                    key: 'category',
                    labelKey: 'catalogProducts.category',
                },
                {
                    key: 'priceList',
                    labelKey: 'catalogProducts.price_base',
                },
                {
                    key: 'department',
                    labelKey: 'catalogProducts.department',
                },
                {
                    key: 'valueIn',
                    labelKey: 'lackOf.in_orders',
                },
                {
                    key: 'manufacturer',
                    labelKey: 'catalogProducts.manufacturer',
                },
                {
                    key: 'lackoFReady',
                    labelKey: 'catalogProducts.status',
                },
            ],
            items: [],
            selectedItem: null,
        }
    },
    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide: 'config/menuHide',
            products: 'catalog/products',
            showProductPopup: 'catalog/showProductPopup',
            leftLovers: 'catalog/leftLovers',
        })
    },
    watch: {
        leftLovers(e) {
            this.items = []
            this.createTableItems(e)
            this.res = e
        },
    },
    created() {
        this.toggleLoadingStatus(true);
        this.getLeftLovers().then(()=>{
            this.toggleLoadingStatus(false);
        });
    },
    methods: {
        createTableItems(e) {
            this.items = []
            e.map(item => {
                this.items.push(
                    {
                        id: item.id,
                        'photo' : item.images,
                        'title' : item && item.title ? item.title : '',
                        'category' : item.category && item.category.tiitle ? item.category.title : "",
                        'priceList' : Number(item.sale_price).toFixed(1),
                        'department': item.department && item.department ? item.department.title : "",
                        'model' : item.model && item.model.title ? item.model.title : '',
                        'lack_less_quantity': item.less_quantity ? item.less_quantity: '',
                        'lack_less_min_quantity': item.minimum ? item.minimum: '',
                        'manufacturer' : item.manufacturer && item.manufacturer.title ? item.manufacturer.title : '',
                        'value' : item.current_less_quantity,
                        'valueIn' : item.in_orders_quantity,
                        'lackoFReady': 1
                    })
            })
        },
        sendLackOfItem(id) {
            let payload = [];
            payload.push(id);
            this.toggleLoadingStatus(true);
            this.changeLeftLovers(payload).then(()=>{
                this.getLeftLovers().then(()=>{
                    this.toggleLoadingStatus(false);
                });
            })
        },
        ...mapActions({
            getLeftLovers: 'catalog/getLeftLovers',
            changeLeftLovers: 'catalog/changeLeftLovers',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        })
    },
}